import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M209.5 80.4L175.9 112l32 88-24 24-47.8-70-24.2 22v24l-24 24-14.2-41.9L31.9 168l24-24h24l24-24-72-48 24-24 88 32 31.7-33.5-.7.5a24 24 0 0134 34z"
      />
    </svg>
  );
}

export default Icon;
